import { render, staticRenderFns } from "./NarliFerryboatView.vue?vue&type=template&id=07138978&"
import script from "./NarliFerryboatView.vue?vue&type=script&lang=js&"
export * from "./NarliFerryboatView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports